const ACTION_LOG_CHUNK_SIZE = 5;

/**
 * @typedef {object} ActionLogEntry
 * @property {string} id
 * @property {string} createdAt
 * @property {string} defaultMessage
 * @property {string} createdBy
 * @property {string} [crewMemberId]
 * @property {string} [crewMemberName]
 */

/**
 * Split a flat list of action-log entries into fixed-size chunks for
 * pagination. Preserves order; the last chunk may be shorter.
 *
 * @param {ActionLogEntry[]} actions
 * @param {number} [size]
 * @returns {ActionLogEntry[][]}
 */
export const buildActionLogChunks = (actions, size = ACTION_LOG_CHUNK_SIZE) => {
	if (!Array.isArray(actions) || actions.length === 0) return [];
	const result = [];
	for (let i = 0; i < actions.length; i += size) {
		result.push(actions.slice(i, i + size));
	}
	return result;
};

export { ACTION_LOG_CHUNK_SIZE };
